import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyBOSjN4HadsH7qGZFzOEPLCB3y29BNlZjM",
  authDomain: "mathgem-49d41.firebaseapp.com",
  projectId: "mathgem-49d41",
  storageBucket: "mathgem-49d41.firebasestorage.app",
  messagingSenderId: "978068993571",
  appId: "1:978068993571:web:74a8a97347275a0790a396",
  measurementId: "G-WMQS8KX106"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage();
export const functions = getFunctions(app);
export const actionCodeSettings = {
  url: 'https://mathsgemseychelles.com',
  handleCodeInApp: false,
};